import { IconProps } from ".";
import Icon from "./assets/link_out_24.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon24LinkOut(props: IconProps) {
  return <BaseIcon icon={<Icon />} {...props} />;
}
